module.exports = __webpack_public_path__ + "img/logo.294deebd.svg";